import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

// ===== Landing Pages =====
import Home from "./Components/Landing_Page/Hero/Home";
import About from "./Components/About/About";
import Work from "./Components/Landing_Page/Work_Samples/Work";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/NavBar/Navbar";
import Preloader from "./Components/Preloader/Preloader";
import Vastu from "./Components/Landing_Page/Vastu/Vastu";
import Sample from "./Components/Landing_Page/Sample/Sample";
import Creditability from "./Components/Landing_Page/Creditability/Creditability";
import ProjectVideos from "./Components/Landing_Page/ProjectVideos/ProjectVideos";
import Testimonials from "./Components/Landing_Page/Testimonials/Testimonials";
import WhatsappButton from "./Components/Floaticon/whatsapp";
import ServiceDetail from "./Components/Landing_Page/Work_Samples/ServiceDetail";

// ===== Admin Pages =====
import AdminRoute from "./Components/Admin/Auth/AdminRoute";
import AdminLogin from "./Components/Admin/Auth/AdminLogin";
import AdminLayout from "./Components/Admin/Dashboard/AdminLayout";
import AdminDashboard from "./Components/Admin/Dashboard/AdminDashboard";
import UploadCategory from "./Components/Admin/Category/UploadCategory";
import CategoryManager from "./Components/Admin/Category/CategoryManager";
import UploadTestimonial from "./Components/Admin/Testimonials/UploadTestimonial";
import TestimonialManager from "./Components/Admin/Testimonials/TestimonialManager";

// 🔹 NEW: Service uploader
import UploadService from "./Components/Admin/Services/UploadService";
import ServiceManager from "./Components/Admin/Services/ServiceManager";

import UploadBlog from "./Components/Admin/Blogs/UploadBlog";
import BlogManager from "./Components/Admin/Blogs/BlogManager";
import EditBlog from "./Components/Admin/Blogs/EditBlog";
import Blogs from "./Components/Blog/Blogs";
import BlogDetail from "./Components/Blog/BlogDetail";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading && <Preloader />}
      <Router>
        <AppContent loading={loading} />
      </Router>
    </div>
  );
}

function AppContent({ loading }) {
  const location = useLocation();

  const isAdminPage =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/category") ||
    location.pathname.startsWith("/testimonial") ||
    location.pathname.startsWith("/service");   // 🔹 include /service route

  return (
    <>
      {!isAdminPage && <Navbar />}

      <Routes>
        {/* ---------- Landing Pages ---------- */}
        <Route
          path="/"
          element={
            <>
              <Home isLoaded={!loading} />
              <WhatsappButton />
              <Work />
              <Vastu />
              <Sample />
              <Creditability />
              <ProjectVideos />
              <Testimonials />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <About />
              
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <Contact />
              
            </>
          }
        />
        <Route path="/category/:slug" element={<ServiceDetail />} />

        {/* ---------- Admin Auth ---------- */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* ---------- Admin Dashboard ---------- */}
        <Route
          path="/dashboard"
          element={
            <AdminRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </AdminRoute>
          }
        />

        {/* ---------- Category Routes ---------- */}
        <Route
          path="/upload-category"
          element={
            <AdminRoute>
              <AdminLayout>
                <UploadCategory />
              </AdminLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/category-manager"
          element={
            <AdminRoute>
              <AdminLayout>
                <CategoryManager />
              </AdminLayout>
            </AdminRoute>
          }
        />

        {/* ---------- Testimonial Routes ---------- */}
        <Route
          path="/upload-testimonial"
          element={
            <AdminRoute>
              <AdminLayout>
                <UploadTestimonial />
              </AdminLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/testimonial-manager"
          element={
            <AdminRoute>
              <AdminLayout>
                <TestimonialManager />
              </AdminLayout>
            </AdminRoute>
          }
        />

        {/* ---------- NEW: Service Routes ---------- */}
        <Route
          path="/upload-service"
          element={
            <AdminRoute>
              <AdminLayout>
                <UploadService />
              </AdminLayout>
            </AdminRoute>
          }
        />

        <Route
          path="/service-manager"
          element={
            <AdminRoute>
              <AdminLayout>
                <ServiceManager />
              </AdminLayout>
            </AdminRoute>
          }
        />
        {/* ---------- Blog Routes ---------- */}
        {/* ---------- Blog Routes ---------- */}
        <Route
          path="/upload-blog"
          element={
            <AdminRoute>
              <AdminLayout>
                <UploadBlog />
              </AdminLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/blog-manager"
          element={
            <AdminRoute>
              <AdminLayout>
                <BlogManager />
              </AdminLayout>
            </AdminRoute>
          }
        />
        <Route
          path="/edit-blog/:id"
          element={
            <AdminRoute>
              <AdminLayout>
                <EditBlog />
              </AdminLayout>
            </AdminRoute>
          }
        />

        {/* ---------- Blog Pages ---------- */}
        <Route
          path="/blogs"
          element={
            <>
              <Blogs />
              
            </>
          }
        />
        <Route
          path="/blogs/:slug"
          element={
            <>
              <BlogDetail />
              
            </>
          }
        />

      </Routes>


      {!isAdminPage && <Footer />}
    </>
  );
}

export default App;